import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { shouldScrollToTop } from '../constants';

const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (shouldScrollToTop(pathname)) {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop; 